module.exports = __webpack_public_path__ + "img/funnel-wellness.78666547.png";